/**
 * Estados/colores de la Agenda de Técnicos (6 tags) y el mapeo desde una VISITA
 * real del ERP (agendamiento tipo VISITA) hacia ese tag. La fuente de la agenda
 * son los agendamientos de visita: llevan flota (técnico), fecha_instalacion,
 * hora_instalacion y estado; si se recoordina cambian y la agenda se refresca.
 */

export type EstadoAgendaTag =
  | 'pendiente'
  | 'en_progreso'
  | 'completado'
  | 'aplazado'
  | 'no_iniciado'
  | 'cancelado';

export const ESTADO_AGENDA_COLOR: Record<EstadoAgendaTag, string> = {
  pendiente: '#2196f3',
  en_progreso: '#ff9800',
  completado: '#4caf50',
  aplazado: '#9e9e9e',
  no_iniciado: '#f44336',
  cancelado: '#757575',
};

export const ESTADO_AGENDA_LABEL: Record<EstadoAgendaTag, string> = {
  pendiente: 'Pendiente',
  en_progreso: 'En Progreso',
  completado: 'Completado',
  aplazado: 'Recoordinado',
  no_iniciado: 'No Iniciado',
  cancelado: 'Cancelado',
};

export const LEYENDA_ESTADOS: { tag: EstadoAgendaTag; label: string; color: string }[] =
  (Object.keys(ESTADO_AGENDA_LABEL) as EstadoAgendaTag[]).map((tag) => ({
    tag,
    label: ESTADO_AGENDA_LABEL[tag],
    color: ESTADO_AGENDA_COLOR[tag],
  }));

/**
 * Deriva el tag de estado (6 colores) de una VISITA del ERP a partir de
 * `estado_agendamiento` + el estado de la OT ligada (`resumen_activacion`,
 * expuesto por el serializer de agendamiento). Nota: "En Progreso" real (visita
 * iniciada sin finalizar) no viene en el listado; queda cubierto por "Pendiente".
 */
export function estadoVisitaAgenda(ag: any): EstadoAgendaTag {
  const estadoAg = String(ag?.estado_agendamiento || '').toUpperCase();
  const ot = ag?.resumen_activacion || {};
  const estadoOT = String(ot?.estado_orden_trabajo || '').toUpperCase();
  const tieneOT = !!(ag?.id_orden_trabajo_actual || ag?.id_orden_trabajo || estadoOT);

  if (estadoOT.startsWith('REALIZADA') || estadoAg === 'FINALIZADO') return 'completado';
  if (
    estadoOT === 'RECHAZADA' ||
    estadoOT === 'PRE-RECHAZADO' ||
    estadoAg === 'CANCELADO' ||
    estadoAg === 'RECHAZADO'
  ) {
    return 'cancelado';
  }
  if (estadoAg === 'RECORDINADO' || estadoAg === 'RECOORDINADO' || estadoOT === 'ESPERA_RECOORDINADA') {
    return 'aplazado';
  }
  if (tieneOT) return 'pendiente';
  return 'no_iniciado';
}
